export function getPromosCount(state) {
  return state.promos_count;
}

export function getAdvertisementsCount(state) {
  return state.advertisements_count;
}

export function getDiscountBeer(state) {
  return state.discount_beer;
}

export function getDiscountsbyAmount(state) {
  return state.discounts_x_amount;
}

export function getSpecialPriceProducts(state) {
  return state.special_price_products;
}